import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";

function RJdForm() {
  const navigate = useNavigate();

  const [id] = useState("");
  const [Description, setDescription] = useState("");
  const [MandatorySkills, setMandatorySkills] = useState("");
  const [OptionalSkills, setOptionalSkills] = useState("");
  const [TotalExperience, setTotalExperience] = useState("");
  const [RelevantExperience, setRelevantExperience] = useState("");
  const [Education, setEducation] = useState("");
  const [Location, setLocation] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = {
      id: id,
      Description: Description,
      MandatorySkills: MandatorySkills.split(","),
      OptionalSkills: OptionalSkills.split(","),
      TotalExperience: TotalExperience,
      RelevantExperience: RelevantExperience,
      Education: Education,
      Location: Location,
    };

    axios
      .post("", formData)
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      }, []);

    console.log("Form Data: ", formData);
    setDescription("");
    setMandatorySkills("");
    setOptionalSkills("");
    setTotalExperience("");
    setRelevantExperience("");
    setEducation("");
    setLocation("");

    navigate("/jd");
  };
  return (
    <>
      <div className="container py-5">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-10 col-md-8 col-lg-6 col-xl-5 log">
            <div className="card border border-dark bg-transparent">
              <div
                className="card-header border-dark text-white"
                style={{ backgroundColor: "#001F3F" }}
              >
                <h4 className="text-center">JD Configurator Form</h4>
              </div>
              <div className="card-body">
                <form>
                  <div className="mb-2">
                    <label className="form-label" htmlFor="Description">
                      Description
                    </label>
                    <input
                      type="text"
                      id="Description"
                      className="form-control bg-transparent"
                      value={Description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label className="form-label" htmlFor="MandatorySkills">
                        Mandatory Skills
                      </label>
                      <input
                        type="text"
                        id="MandatorySkills"
                        className="form-control bg-transparent"
                        value={MandatorySkills}
                        onChange={(e) => setMandatorySkills(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label htmlFor="OptionalSkills" className="form-label">
                        Optional Skills
                      </label>
                      <input
                        type="text"
                        className="form-control bg-transparent"
                        id="OptionalSkills"
                        aria-describedby="emailHelp"
                        value={OptionalSkills}
                        onChange={(e) => setOptionalSkills(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label htmlFor="TotalExperience" className="form-label">
                        Total Experience
                      </label>
                      <input
                        type="text"
                        className="form-control bg-transparent"
                        id="TotalExperience"
                        aria-describedby="emailHelp"
                        value={TotalExperience}
                        onChange={(e) => setTotalExperience(e.target.value)}
                      />
                    </div>

                    <div className="col-md-6 mb-2">
                      <label
                        htmlFor="RelevantExperience"
                        className="form-label"
                      >
                        Relevant Experience
                      </label>
                      <input
                        type="text"
                        className="form-control bg-transparent"
                        id="RelevantExperience"
                        aria-describedby="emailHelp"
                        value={RelevantExperience}
                        onChange={(e) => setRelevantExperience(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <label htmlFor="Education" className="form-label">
                        Education
                      </label>
                      <input
                        type="text"
                        className="form-control bg-transparent"
                        id="Education"
                        aria-describedby="emailHelp"
                        value={Education}
                        onChange={(e) => setEducation(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <label htmlFor="Location" className="form-label">
                        Location
                      </label>
                      <input
                        type="text"
                        className="form-control bg-transparent"
                        id="Location"
                        aria-describedby="emailHelp"
                        value={Location}
                        onChange={(e) => setLocation(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="text-center py-2">
                    <button
                      type="submit"
                      className="btn text-white me-2"
                      onClick={handleSubmit}
                      style={{ backgroundColor: "#001F3F" }}
                    >
                      Submit
                    </button>
                    <button
                      className="btn btn-danger"
                      type="button"
                      onClick={() => (window.location.href = "/dash")}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RJdForm;
